import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'OpsCenter/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { LoyaltyPointsComponent } from 'OpsCenter/ops-support/loyalty-points/loyalty-points.component';
import { LoyaltyPointsService } from 'OpsCenter/ops-support/loyalty-points/loyalty-points.service';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [HttpClientModule, CommonModule, SharedModule, FormsModule, NgbPaginationModule],
  declarations: [LoyaltyPointsComponent],
  providers: [LoyaltyPointsService],
  entryComponents: [LoyaltyPointsComponent],
})
export class LoyaltyPointsModule {

}



// WEBPACK FOOTER //
// ./src/app/ops-support/loyalty-points/loyalty-points.module.ts